import React from 'react';
import { observer } from 'mobx-react';
import { OEToggle } from '../../global/oe-toggle/oe-toggle';
import Text from '../../global/text/text';
import { OrderBookingFormVM } from './order-booking-form.viewmodel';
import { CommonPopupBodyFooterLayout } from '../../global/common-popup/common-popup-body-footer-layout';
import { INTERNAL_NOTIFICATION_EMAIL_TEXT, ORDER_BOOKING_STATUS_TEXT } from '../account-admin.text';
import { AccountAdminSettingFormFooter } from '../common/account-admin-setting-form-footer';
import { FormattedMessage } from 'react-intl';
import { ADD_BLUEPRINTS_TEXT, BLUEPRINTS_TEXT, LOADING, REMOVE_TEXT } from '../../../constants/common-labels.constants';
import { SingleSelectButton } from '../../global/single-select/single-select-button';
import DefaultButton from '../../global/default-button/default-button';
import './order-booking.scss';
import { FormField } from '../../global/form/form-field/form-field';
import { ENTER_COMMA_SEPARATED_LIST_OF_EMAILS, INTERNAL_NOTIFICATION_EMAIL_HOVER_INFO, NEW_BLUEPRINT_TEXT } from './../../../../app/constants/order-booking.constants';
import { AddNewEntityButton } from '../../global/add-new-entity/add-new-entity-button';
import { Permission } from '../../../api/roles.dao';
import { InfoPopover } from '../../global/info-popover/info-popover';

interface IProps {
    vm: OrderBookingFormVM;
}

const OrderBookingFormPresentation = observer((props: IProps) => {
    const { vm } = props;
    const { intl } = vm;

    return (
        <CommonPopupBodyFooterLayout
            body={
                <>
                    <div className='oe-form order-booking-form'>
                        {vm.isLoading ? (
                            <FormattedMessage
                                {...LOADING}
                                values={{
                                    suffix: '...',
                                }}
                            />
                        ) : (
                            <div className='oe-form__body'>
                                <div className='m-top-10px m-bottom-0px flex center'>
                                    <OEToggle
                                        isSelected={vm.settingsEntity.enabled}
                                        onClick={vm.settingsEntity.toggleEnabled}
                                        dataTestId='toggle-order-booking'
                                    />
                                    <Text
                                        {...ORDER_BOOKING_STATUS_TEXT}
                                        values={{
                                            suffix: vm.settingsEntity.suffix,
                                        }}
                                        className='line-height-25px'
                                    />
                                </div>
                                {vm.settingsEntity.enabled &&
                                    <div className='m-top-10px m-bottom-0px'>
                                        <div className='event_form__items-section'>
                                            <div className='event_form__items-section__title'>
                                                <FormattedMessage {...BLUEPRINTS_TEXT} />
                                            </div>
                                            <div className='event_form__items-section__selected-items'>
                                                {vm.sortedBlueprints().map(({ name, blueprintId }) => (
                                                    <div
                                                        key={blueprintId}
                                                        className='event_form__items-section__item-wrapper'
                                                    >
                                                        <Text
                                                            className='event_form__items-section__item-label'
                                                            message={name}
                                                            withEllipsis
                                                        />
                                                        <DefaultButton
                                                            text={<FormattedMessage {...REMOVE_TEXT} />}
                                                            modifier='remove'
                                                            onClick={() => vm.removeEventBlueprint(blueprintId)}
                                                            className='event_form__items-section__remove-item-button'
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                            <SingleSelectButton
                                                className='default-button add-line-to-table-btn'
                                                items={vm.listEventBlueprints}
                                                value={intl.formatMessage(ADD_BLUEPRINTS_TEXT)}
                                                onClick={vm.fetchEventBlueprints.bind(vm)}
                                                onChange={vm.openAddOrderBookingEventBlueprintPopup}
                                                nameProperty='name'
                                                keyProperty='blueprintId'
                                                disabled='disabled'
                                                ActionButton={() => (
                                                    <AddNewEntityButton
                                                        permission={Permission.CREATE_EVENT_BLUEPRINTS}
                                                        onClick={vm.openCreateEventBlueprintForm}
                                                        label={intl.formatMessage(NEW_BLUEPRINT_TEXT, { prefix: '+ ' })}
                                                    />
                                                )}
                                            />
                                        </div>
                                        <div className='event_form__items-section'>
                                            <div className='event_form__items-section__title'>
                                                <FormattedMessage {...INTERNAL_NOTIFICATION_EMAIL_TEXT} />
                                                <InfoPopover className='info-popover'>
                                                    <div>{INTERNAL_NOTIFICATION_EMAIL_HOVER_INFO.defaultMessage}</div>
                                                </InfoPopover>
                                            </div>
                                            <div>
                                                <FormField>
                                                    <input
                                                        value={vm.internalNotificationEmails}
                                                        onChange={e => vm.setOrderBookingEmails(e.target.value)}
                                                        onBlur={() => vm.setFieldTouched()}
                                                    />
                                                    {
                                                        vm.isFormChecked && vm.getEmailsValidationMessage() &&
                                                        <span className='oe-form-field__error'>
                                                            {vm.getEmailsValidationMessage()}
                                                        </span>
                                                    }
                                                    <div className='oe-form-field__title'>{intl.formatMessage(ENTER_COMMA_SEPARATED_LIST_OF_EMAILS)}</div>
                                                </FormField>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        )}
                    </div>
                </>
            }
            footer={
                <AccountAdminSettingFormFooter
                    handleClose={vm.handleClose}
                    handleSubmit={vm.handleSubmit}
                    isDisabled={vm.saving || vm.isUpdating}
                    hideApplyAndCloseButton={true}
                    closeWhenClickApplyButton={true}
                />
            }
        />
    );
});

export { OrderBookingFormPresentation };